var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFlagTriangle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.609 5.85693L3.75 1.47705V1C3.75 0.586 3.414 0.25 3 0.25C2.586 0.25 2.25 0.586 2.25 1V18.25H1C0.586 18.25 0.25 18.586 0.25 19C0.25 19.414 0.586 19.75 1 19.75H5C5.414 19.75 5.75 19.414 5.75 19C5.75 18.586 5.414 18.25 5 18.25H3.75V13.522L15.609 9.14209C16.302 8.88609 16.75 8.24102 16.75 7.49902C16.75 6.75702 16.302 6.11393 15.609 5.85693ZM15.089 7.73511L3.75 11.9231V3.07593L15.089 7.26392C15.222 7.31292 15.25 7.41902 15.25 7.49902C15.25 7.57902 15.222 7.68711 15.089 7.73511Z",
    fill: "#25314C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlagTriangle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/flag-triangle.8f9e7e6e74501d5d4114b8b7a5e1c0ff.svg";